var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaginationDoubleArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.221 10.5a3.332 3.332 0 0 1 .973-2.36L9.64 2.697a.67.67 0 0 1 .946.946L5.14 9.087a2 2 0 0 0 0 2.826l5.445 5.445a.67.67 0 0 1-.946.946l-5.445-5.445a3.332 3.332 0 0 1-.973-2.359z",
    fill: "#A2A1AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 10.5a3.332 3.332 0 0 1 .973-2.36l5.445-5.444a.67.67 0 1 1 .946.946l-5.445 5.445a2 2 0 0 0 0 2.826l5.445 5.445a.67.67 0 1 1-.946.946l-5.445-5.445A3.332 3.332 0 0 1 8.44 10.5z",
    fill: "#A2A1AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/pagination-double-arrow-left.cc1c5ecfcd29c320db038d40bcf5b87e.svg";
export { ForwardRef as ReactComponent };